import script from "./task.vue?vue&type=script&setup=true&lang=js"
export * from "./task.vue?vue&type=script&setup=true&lang=js"

import "./task.vue?vue&type=style&index=0&id=3a014003&scoped=true&lang=scss"

import exportComponent from "D:\\project\\2024\\htos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a014003"]])

export default __exports__